var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormGroup",
    {
      attrs: {
        state: _vm.startValid && _vm.endValid,
        "invalid-feedback": _vm.error,
        "feedback-beneath": ""
      }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-md-center flex-column flex-md-row" },
        [
          _c(
            "div",
            [
              _c("DatePicker", {
                staticClass: "w-auto",
                attrs: {
                  disabled: _vm.disabled,
                  "years-in-past": 80,
                  "years-in-future": 0,
                  "year-reverse": "",
                  "with-day": false,
                  "switch-month-year": ""
                },
                on: { input: _vm.emitChangeEvent },
                model: {
                  value: _vm.start,
                  callback: function($$v) {
                    _vm.start = $$v
                  },
                  expression: "start"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mx-md-3" }, [_vm._v("bis")]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticClass: "d-flex align-items-center md-ml-1" },
              [
                _c("DatePicker", {
                  staticClass: "w-auto",
                  attrs: {
                    disabled: _vm.disabled || !_vm.endDateEligible,
                    "years-in-past": 80,
                    "years-in-future": 0,
                    "year-reverse": "",
                    "with-day": false,
                    "switch-month-year": ""
                  },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.end,
                    callback: function($$v) {
                      _vm.end = $$v
                    },
                    expression: "end"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ml-md-3" },
            [
              _c(
                "b-form-checkbox",
                {
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.ongoing,
                    callback: function($$v) {
                      _vm.ongoing = $$v
                    },
                    expression: "ongoing"
                  }
                },
                [_vm._v("aktuell")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }